<div style="height:400px;">
    <ag-grid-angular #agGrid style="height: 170px;" class="full-width-grid ag-theme-alpine" [columnDefs]="colDefs"
        [defaultColDef]="defaultColDef" [rowData]="rowData" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
    <br>
    <app-bar-chart></app-bar-chart>
</div>
